export const shortenAddress = (address: string, chars = 8) => {
  return `${address.substring(0, chars - 2)}...${address.substring(44 - chars)}`
}
